interface HeaderProps {
  title?: string;
  subtitle?: string;
  logoUrl?: string;
  primaryColor?: string;
  onClose: () => void;
}

export function Header({
  title = "CivicCity, KS Ai",
  subtitle = "Powered by CivicPlus",
  logoUrl,
  primaryColor = "#CC0020",
  onClose,
}: HeaderProps) {
  return (
    <header
      className="flex items-center justify-between gap-3 rounded-t-xl px-3 py-3"
      style={{
        background: `linear-gradient(135deg, rgba(135, 135, 135, 0.5) 0%, rgba(66, 66, 66, 0.7) 100%), ${primaryColor}`,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="relative z-10 flex flex-col gap-1">
        <h1
          className="text-xl font-bold leading-none text-[#FAFAFA]"
          style={{ textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)" }}
        >
          {title}
        </h1>
        <p
          className="text-xs font-normal leading-none text-[#FAFAFA]"
          style={{ textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)" }}
        >
          {subtitle}
        </p>
      </div>
      <button
        onClick={onClose}
        aria-label="Close chat"
        className="relative z-10 flex h-8 w-8 items-center justify-center rounded bg-white transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-gray-700"
          aria-hidden="true"
        >
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </header>
  );
}
